export class ErrorData extends Error {
    public code: string | undefined;
    public originalCode: string | undefined;
}